import React from 'react';
import { Button, Card, CardContent, Fab, Grid, ListItemIcon, ListItemText, Menu, MenuItem, Modal, Stack, TextField, Tooltip } from '@mui/material';
import config from 'src/config';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import showLoading from 'src/common/loading';
import NoteAddIcon from '@mui/icons-material/NoteAdd';
import { addFile, createOfficeFile } from 'src/services/file.service';
import DrawIcon from '@mui/icons-material/Draw';
import SlideshowIcon from '@mui/icons-material/Slideshow';
import GridOnIcon from '@mui/icons-material/GridOn';

// ----------------------------------------------------------------------



class CreateOfficeFileModal extends React.Component {

	constructor(props) {
		super(props);

		this.state = {

			role: localStorage.getItem('role') || config.USER_ROLES.USER,
			mode: 'add',
			add_view_type: 'fab',
			is_modal_open: this.props.open || false,
			
			menu_anchor_el: null,
			menu_open: false,
			selected_menu: null,

			name: ''
		}
	}

	// promised setState
	setStateAsync(state) {
		return new Promise((resolve) => {
			this.setState(state, resolve)
		});
	}

	isFormValid() {
		if (!this.state.name || this.state.name.trim() === '') {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: 'Name is required'
			});
			return false;
		}
		return true;
	}

	async createOfficeFile(type) {

		if (!this.isFormValid())
			return;

		showLoading(true);
		
		// TODO: Create the office file based on the type

		let createOfficeFileRes = await createOfficeFile({
			name: this.state.name,
			type: type,
		});
		
		if (createOfficeFileRes.error) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: createOfficeFileRes.error
			});
		} else {
			Swal.fire({
				icon: 'success',
				title: 'Success',
				text: 'File created successfully'
			});
			this.setState({
				is_modal_open: false,
				name: ''
			});
			if (this.props.onClose)
				this.props.onClose();
			if (this.props.onCreate)
				this.props.onCreate(createOfficeFileRes);
		}
	}

	async addFile(type) {

		if (!this.isFormValid())
			return;

		showLoading(true);
		
		let addFileRes = await addFile({
			name: this.state.name,
			category: 'design',
			sub_category: 'design',
			type: type,
		});

		if (addFileRes.error) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: addFileRes.error
			});
		} else {

			// close the modal and reset the state
			Swal.close();

			this.setState({
				is_modal_open: false,
				name: ''
			});
			if (this.props.onClose)
				this.props.onClose();
			if (this.props.onCreate)
				this.props.onCreate(addFileRes);


			if (type === 'excalidraw' && addFileRes?.file?._id) {
				this.props.navigate('/integrations/excalidraw/app?fileId=' + addFileRes?.file?._id);
			}
		}
	}

	async createFile() {
		if (!this.state.selected_menu) {
			Swal.fire({
				icon: 'error',
				title: 'Error',
				text: 'Please select a file type to create'
			});
			return;
		}
		if (this.state.selected_menu === 'word' || this.state.selected_menu === 'powerpoint' || this.state.selected_menu === 'excel') {
			this.createOfficeFile(this.state.selected_menu);
		} else if (this.state.selected_menu === 'excalidraw') {
			this.addFile(this.state.selected_menu);
		}
	}

	async handleCreateFile(type) {
		this.handleMenuClose();
		this.setState({
			is_modal_open: true,
			selected_menu: type,
			mode: 'add',
			name: ''
		});
	}

	async handleMenuOpen(e) {
		this.setState({
			menu_open: true,
			mode: 'add',
			name: '',
			menu_anchor_el: e.currentTarget
		});
	}

	async handleMenuClose() {
		this.setState({
			menu_open: false
		});
	}

	render() {
		return (
			<>
			{(!this.props.hideAddButton) ? (
				<>
				{/* <Stack direction="row" spacing={1} alignItems="center">
					<Tooltip title="Create Sketch" placement="top">
						<Fab size="small" color="secondary" aria-label="add"
							onClick={() => this.handleCreateFile('excalidraw')}
						>
							<DrawIcon />
						</Fab>
					</Tooltip>
					<Tooltip title="Create File" placement="top">
						<Fab size="small" color="secondary" aria-label="add"
							onClick={this.handleMenuOpen.bind(this)}
						>
							<NoteAddIcon />
						</Fab>
					</Tooltip>
				</Stack>
				<Menu
					id="create-file-menu"
					anchorEl={this.state.menu_anchor_el}
					open={this.state.menu_open}
					onClose={this.handleMenuClose.bind(this)}
					slotProps={{
						list: {
							'aria-labelledby': 'create-file-menu',
						},
					}}
				>
					<MenuItem onClick={() => this.handleCreateFile('word')}>Create Document</MenuItem>
					<MenuItem onClick={() => this.handleCreateFile('powerpoint')}>Create Presentation</MenuItem>
					<MenuItem onClick={() => this.handleCreateFile('excel')}>Create Spreadsheet</MenuItem>
				</Menu> */}

				<MenuItem onClick={() => this.handleCreateFile('excalidraw')}>
					<ListItemIcon>
						<DrawIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText>Create Drawing</ListItemText>
				</MenuItem>
				<MenuItem onClick={() => this.handleCreateFile('word')}>
					<ListItemIcon>
						<NoteAddIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText>Create Document</ListItemText>
				</MenuItem>
				<MenuItem onClick={() => this.handleCreateFile('powerpoint')}>
					<ListItemIcon>
						<SlideshowIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText>Create Presentation</ListItemText>
				</MenuItem>
				<MenuItem onClick={() => this.handleCreateFile('excel')}>
					<ListItemIcon>
						<GridOnIcon fontSize="small" />
					</ListItemIcon>
					<ListItemText>Create Spreadsheet</ListItemText>
				</MenuItem>
				</>
			) : null}
			<Modal
				open={this.state.is_modal_open}
				onClose={() => {
					this.setState({
						is_modal_open: false,
						selected_menu: null,
						name: ''
					});
					if (this.props.onClose)
						this.props.onClose();
				}}
			>
				<Grid container>
					<Grid item style={modalStyle} xs={12} md={8} lg={6}>
						<Card variant='outlined'>
							<CardContent style={{ padding: 20 }}>
								<Stack direction="column" spacing={2}>
									<TextField
										size='small'
										label={'Name'}
										variant="outlined"
										fullWidth
										value={this.state.name}
										onChange={(e) => {
											this.setState({
												name: e.target.value
											});
										}}
										onKeyDown={(e) => {
											if (e.key === 'Enter') {
												this.createFile();
											}
										}}
									/>
									
									<Button
										variant='contained'
										fullWidth
										color='primary'
										onClick={async () => {
											this.createFile();
										}}
									>
										Create
									</Button>
								</Stack>
							</CardContent>
						</Card>
					</Grid>
				</Grid>
			</Modal>
			</>
		);
	}
}

const modalStyle = {
	position: 'absolute',
	top: '50%',
	left: '50%',
	transform: 'translate(-50%, -50%)',
	width: '100%',
	bgcolor: 'background.paper',
	boxShadow: 24,
	p: 2,
	maxHeight: '90%',
	overflowY: 'auto'
};

export default function (props) {
	const navigate = useNavigate();

	return <CreateOfficeFileModal {...props} navigate={navigate} />;
}
